import { gql } from "@apollo/client";

export const DELETE_VENUE = gql`
  mutation removeVenue($id: Int!) {
    removeVenue(id: $id) {
      id
    }
  }
`;
